import styles from './shop-by-brand-thumbnail.module.css'
import { createElement } from 'react'

interface ShopByBrandThumbnailProps {
  title?: string
  href?: string
  image?: string
  alt?: string
  handleTrackEvent: () => void
}

export const ShopByBrandThumbnail = ({
  title,
  href,
  image,
  alt,
  handleTrackEvent,
}: ShopByBrandThumbnailProps) => {
  const handleLinkTrackingEvent = () => {
    handleTrackEvent()
  }

  const children = (
    <>
      {image && alt && (
        <div aria-hidden="true" title={title}>
          <img src={image} alt={alt} />
        </div>
      )}
      {title && <h2 className={styles.text}>{title}</h2>}
    </>
  )

  let element = createElement(
    'div',
    {
      className: styles.container,
      onClick: handleLinkTrackingEvent,
    },
    children,
  )

  if (href) {
    element = createElement(
      'a',
      {
        className: styles.container,
        onClick: handleLinkTrackingEvent,
        href,
      },
      children,
    )
  }

  return element
}
